import { render, staticRenderFns } from "./AdManage.vue?vue&type=template&id=22ccf5b8&scoped=true&"
import script from "./AdManage.vue?vue&type=script&lang=ts&"
export * from "./AdManage.vue?vue&type=script&lang=ts&"
import style0 from "./AdManage.vue?vue&type=style&index=0&id=22ccf5b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ccf5b8",
  null
  
)

export default component.exports